import React, { useState, useEffect } from "react";
import { IoIosClose } from "react-icons/io";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useForm } from "react-hook-form";
import RequestService from "../../services/RequestService";
import MinorRequestDetails from './../molecules/MinorRequestDetails';
import { parseISO, format } from "date-fns";
import StatusRequests from '../../enums/StatusRequests'
import { MdSend, MdWarning } from "react-icons/md";

// A partir de quantos atendimentos no mesmo boleto o alerta é exibido.
// 3+ Requests com o mesmo idBoleto significam 3 pedidos de peças para o mesmo
// chamado da Vivo — o operador precisa conferir antes de iniciar mais um.
const LIMITE_ATENDIMENTOS_BOLETO = 3;

export default function InitiateRequestModal({
  isModalOpen,
  setModalOpen,
  requestId,
  requestNro,
  // setTicketCb
}) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm();

  const [requestObject, setRequestObject] = useState();

  // Atendimentos que compartilham o mesmo boleto desta solicitação.
  // { total, requests } — null enquanto não consultado / sem boleto.
  const [boletoInfo, setBoletoInfo] = useState(null);

  const [atualizadoSGRS, setAtualizadoSGRS] = useState(false);

  const handleAtualizadoSGRSChange = (event) => {
    setAtualizadoSGRS(event.target.checked);
  };

  useEffect(() => {
    async function fetchRequest() {
      const request = await RequestService.getRequestById(requestId);
      setRequestObject(request);
      console.log(request?.request.idRequest);
    }

    fetchRequest();
  }, [isModalOpen, requestId]);

  // Ao abrir o modal, busca todos os atendimentos do mesmo boleto para avisar
  // quando já houver 3 ou mais pedidos de peças para o mesmo chamado da Vivo.
  useEffect(() => {
    const idBoleto = requestObject?.request?.idBoleto;

    if (!isModalOpen || !idBoleto) {
      setBoletoInfo(null);
      return;
    }

    let cancelado = false;

    async function fetchAtendimentosDoBoleto() {
      try {
        // limit alto o bastante para listar todos os chamados do boleto.
        const data = await RequestService.getRequest(
          `?idboleto=${encodeURIComponent(idBoleto)}`, 1, 50
        );
        if (cancelado) return;
        setBoletoInfo({
          total: data?.totalRequests || 0,
          requests: data?.requests || [],
        });
      } catch (error) {
        // Falha na consulta não pode travar o modal — apenas não exibe o alerta.
        console.error("Erro ao consultar atendimentos do boleto:", error);
        if (!cancelado) setBoletoInfo(null);
      }
    }

    fetchAtendimentosDoBoleto();

    return () => { cancelado = true; };
  }, [isModalOpen, requestObject?.request?.idBoleto]);

  const totalAtendimentosBoleto = boletoInfo?.total || 0;
  const exibirAlertaBoleto = totalAtendimentosBoleto >= LIMITE_ATENDIMENTOS_BOLETO;
  // Desdobramentos herdam o idBoleto do pai — não são um novo pedido, então
  // são sinalizados à parte para o operador interpretar o total corretamente.
  const desdobramentosBoleto = (boletoInfo?.requests || []).filter((r) => r.isChild).length;

  const onSubmit = async (data) => {
    // const now = new Date().toLocaleString(undefined, {
    //   year: '2-digit',
    //   month: '2-digit',
    //   day: '2-digit',
    //   hour: '2-digit',
    //   minute: '2-digit',
    // });

    
    // Adicionar o prefixo "GESTÃO: " ao valor do campo observacao
    // if (!requestObject.request.observacao)
    //     data.observacao = `${now} - ${requestObject?.request?.status}: ${data.observacao}`;
    // else
    // data.observacao = `${requestObject?.request?.observacao}\n------\n${now} - ${requestObject?.request?.status}: ${data.observacao}`;

    data = { ...data, status: "BACKOFFICE" };   

    const response = await RequestService.updateParcial(requestId, data);

    if (response) {
      toast.success("Enviado para Backoffice!");
    } else {
      toast.error("Ops! Algo deu errado");
    }

    setModalOpen(!isModalOpen);
    reset();
  };

  const onClose = () => {
    setModalOpen(!isModalOpen);
    setAtualizadoSGRS(false);
    reset();
  };

  if (isModalOpen) {
    return (
      <div
        className="flex flex-col relative z-10"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto"
          onClick={onClose}
        >
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <div className="flex flex-col max-w-[700px] h-fit pb-4 relative transform rounded-lg bg-white text-left shadow-xl transition-all" onClick={(e) => e.stopPropagation()}>
              <button
                onClick={onClose}
                className="absolute -top-7 -right-7 rounded-full p-1"
              >
                <div className="w-12 h-12 flex bg-gray-200 justify-center items-center rounded-full ms-6">
                  <div className="flex justify-center items-center">
                    <IoIosClose color={"black"} size={32} />
                  </div>
                </div>
              </button>
              <div className="flex flex-col px-4 pt-4 pb-3 text-left gap-2 bg-gray-800 text-white rounded-t-lg">

                <div className="flex justify-between gap-2">
                  <div className="flex gap-2 items-center text-white text-xl font-bold">
                    <MdSend />
                    INICIAR ATENDIMENTO
                  </div>

                  {requestObject?.request?.isReplica &&
                    <div>
                      <p className="text-black font-bold rounded-lg px-1 bg-yellow-300">
                        RÉPLICA SGRS
                      </p>
                    </div>
                  }
                </div>

                <div className="ms-4 flex justify-between">
                  <div className="text-sm">
                    Solicitação nº: {requestObject?.request?.idRequest}
                  </div>
                  <div className="text-sm">
                    {/* Criado em: {requestObject?.request?.createdAt } */}
                    Criado em: {requestObject && format(parseISO(requestObject?.request?.createdAt), 'dd/MM/yy HH:mm')}
                  </div>
                  <div className="flex items-center gap-2">
                    Status:
                    <p className="text-sm text-black rounded-lg px-2"
                      style={{ backgroundColor: StatusRequests[requestObject?.request?.status]?.cor }}>
                      {requestObject?.request?.status}
                    </p>
                  </div>
                </div>
              </div>

              {/* Alerta: 3+ atendimentos no mesmo boleto */}
              {exibirAlertaBoleto &&
                <div className="mx-4 mt-4 rounded-lg border-2 border-red-500 bg-red-50 px-4 py-3">
                  <div className="flex items-start gap-2">
                    <div className="pt-0.5 text-red-600">
                      <MdWarning size={22} />
                    </div>
                    <div className="flex flex-col gap-1">
                      <div className="text-red-700 font-bold text-sm">
                        ATENÇÃO: este boleto já possui {totalAtendimentosBoleto} atendimentos
                      </div>
                      <div className="text-red-700 text-xs">
                        O boleto <span className="font-bold">{requestObject?.request?.idBoleto}</span> já
                        teve {totalAtendimentosBoleto} pedidos no Vision para o mesmo chamado Vivo.
                        Confira o histórico antes de iniciar mais um atendimento.
                      </div>

                      {desdobramentosBoleto > 0 &&
                        <div className="text-red-600 text-[11px] italic">
                          {desdobramentosBoleto === 1
                            ? "1 desses atendimentos é um desdobramento (mesmo pedido dividido)."
                            : `${desdobramentosBoleto} desses atendimentos são desdobramentos (mesmo pedido dividido).`}
                        </div>
                      }

                      <div className="mt-1 max-h-28 overflow-y-auto flex flex-col gap-1 pr-1">
                        {boletoInfo?.requests?.map((req) => (
                          <div key={req._id} className="flex items-center gap-2 text-[11px] text-gray-700">
                            <span className="font-bold w-24">{req.idRequest}</span>
                            <span
                              className="rounded-lg px-2 text-black whitespace-nowrap"
                              style={{ backgroundColor: StatusRequests[req.status]?.cor }}
                            >
                              {req.status}
                            </span>
                            <span className="whitespace-nowrap">
                              {req.createdAt && format(parseISO(req.createdAt), 'dd/MM/yy HH:mm')}
                            </span>
                            <span className="truncate">{req.codSap}</span>
                            {req.isChild &&
                              <span className="rounded-lg px-2 bg-orange-200 text-orange-800 whitespace-nowrap">
                                desdobramento
                              </span>
                            }
                            {req._id === requestObject?.request?._id &&
                              <span className="font-bold text-red-700 whitespace-nowrap">(este)</span>
                            }
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              }

              <MinorRequestDetails request={requestObject?.request} divBoleto={true} divContato={true}/>

              {/* MODAL FORM BEGIN */}

              <div className="flex flex-col mt-6 px-12">
                <div className="w-full relative inline-block text-left">
                  <div className="w-full flex flex-col text-sm">
                    <div className="flex flex-col items-start gap-1 mb-4 w-full">
                      <div className="w-1/5 block text-gray-700 font-bold whitespace-nowrap">
                        Iniciar o atendimento desta solicitação?
                      </div>
                      <div className="w-1/5 block text-red-700 italic whitespace-nowrap">
                        Esta ação não pode ser desfeita
                      </div>
                      {requestObject?.request?.isReplica &&
                        <div className="flex gap-2">
                          <input
                            type="checkbox"
                            checked={atualizadoSGRS}
                            onChange={handleAtualizadoSGRSChange}
                            className="form-checkbox h-4 w-4 text-blue-600"
                          />
                          <label className="text-gray-700 font-bold whitespace-nowrap text-xs">
                            Confirmo que já atualizei no SGRS
                          </label>
                        </div>
                      }
                    </div>

                    <div className="flex gap-4">
                      <button
                        disabled={!requestObject?.request?.isReplica ? false : atualizadoSGRS ? false : true}
                        onClick={() => handleSubmit(onSubmit)()}
                        className="w-full bg-blue-500 text-white py-2 px-4 rounded-2xl hover:bg-blue-600 disabled:bg-gray-200"
                      >
                        Sim
                      </button>

                      <button
                        onClick={() => setModalOpen(!isModalOpen)}
                        className="w-full bg-gray-500 text-white py-2 px-4 rounded-2xl hover:bg-gray-600"
                      >
                        Não
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    );
  }
}
